import { render, staticRenderFns } from "./FederationsListPage.vue?vue&type=template&id=20baa7b1"
import script from "./FederationsListPage.vue?vue&type=script&lang=js"
export * from "./FederationsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports